import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'
import * as modules from './modules'

Vue.use(Vuex)

export async function createStore () {
  const store = new Vuex.Store({
    plugins: [
      createPersistedState({
        key: 'persistedState',
        storage: window.localStorage,
        paths: [
          'passport.token',
          'passport.refreshToken',
          'language.language'
        ]
      }),
      createPersistedState({
        key: 'persistedSessionState',
        storage: window.localStorage,
        paths: [
          'passport.context',
          'language.language'
        ]
      })
    ],
    modules: Object.entries(modules)
    .map(([key, factory]) => {
      return {
        key,
        value: factory()
      }
    })
    .reduce((t, entry) => ({
      ...t,
      [entry.key]: entry.value
    }), {}),
  })

  await store.dispatch('passport/restore')

  return store
}
